import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-md-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = { class: "col px-0" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { class: "col px-0" }
const _hoisted_10 = ["id"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fancybox_component = _resolveComponent("fancybox-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_fancybox_component, { ref: "fancyboxImages" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (src, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: index,
              href: src,
              "data-fancybox": "images",
              class: "gallery-link"
            }, null, 8, _hoisted_4))
          }), 128)),
          (_ctx.images.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openGallery('image')), ["prevent"])),
                    class: "btn btn-outline-dark w-100 rounded-bottom"
                  }, _toDisplayString(_ctx.$t.viewImages), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512),
      _createVNode(_component_fancybox_component, { ref: "fancyboxPDFs" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pdfs, (src, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: 'pdf-' + index,
              href: src,
              "data-fancybox": "pdfs",
              "data-type": "iframe",
              "data-options": "{\"iframe\": {\"preload\": false}}",
              class: "gallery-link"
            }, null, 8, _hoisted_7))
          }), 128)),
          (_ctx.pdfs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openGallery('pdf')), ["prevent"])),
                    class: "btn btn-outline-dark w-100 rounded-bottom"
                  }, _toDisplayString(_ctx.$t.viewPDFs), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", {
        id: 'uppyDashboard' + this.object.Region,
        style: {"width":"100%"}
      }, null, 8, _hoisted_10)
    ]),
    _hoisted_11
  ]))
}